import JVPCList from './JVPCList'

/* istanbul ignore next */
JVPCList.install = function (Vue) {
  Vue.component(JVPCList.name, JVPCList)
}

export default JVPCList
